interface SentimentCardProps {
  sentiment: { support: number; oppose: number; neutral: number };
  commentCount: number;
}

const ROWS = [
  { key: "oppose", label: "质疑反对", color: "bg-primary-500", text: "text-primary-700" },
  { key: "support", label: "支持理解", color: "bg-secondary-500", text: "text-secondary-700" },
  { key: "neutral", label: "围观中立", color: "bg-accent-500", text: "text-accent-700" },
] as const;

export default function SentimentCard({ sentiment, commentCount }: SentimentCardProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-5">
      <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
        <i className="ri-bar-chart-2-line text-lg text-primary-600" />
        评论区风向
      </h3>
      <p className="mt-1 text-xs text-foreground-500">
        基于 {commentCount.toLocaleString("zh-CN")} 条公开评论的人工分类统计
      </p>

      <div className="mt-4 flex h-3 w-full overflow-hidden rounded-full">
        {ROWS.map((row) => (
          <div
            key={row.key}
            className={row.color}
            style={{ width: `${sentiment[row.key]}%` }}
            aria-hidden="true"
          />
        ))}
      </div>

      <ul className="mt-4 flex flex-col gap-2.5">
        {ROWS.map((row) => (
          <li key={row.key} className="flex items-center justify-between text-sm">
            <span className="flex items-center gap-2 text-foreground-700">
              <span className={`h-2.5 w-2.5 rounded-full ${row.color}`} />
              {row.label}
            </span>
            <span className={`font-bold ${row.text}`}>{sentiment[row.key]}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}